export * from './object/is-object.js';
